import * as _ from 'lodash';

import './addons.scss';
import template from './addons.html';

import AbstractSectionController from '../AbstractSectionController';

class AccountBillingController extends AbstractSectionController {
    /*@ngInject*/
    constructor(
        $q, $uibModal, $filter, $state, $timeout, $cookies,
        dataContext, alertService, constants) {

        super();
        this.$q = $q;
        this.$uibModal = $uibModal;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$state = $state;
        this.dataContext = dataContext;
        this.alertService = alertService;
        this.constants = constants;
        this.$cookies = $cookies;
        this.listOfAIDAddonServices = [];


        //this.isCameraPlan = monitoringPlansService.isSAVPlan(dataContext.user.current.ServicePlanInfo);
        this.customerInfoReady = this.dataContext.account.getCustomerInformationV2()
            .then((result) => {
                this.customerInformation = result;

                if (this.customerInformation && this.customerInformation.PremisesAddress) {
                    this.showAddOnsSection = this.customerInformation.PremisesAddress.Country.trim() === 'USA' && this.customerInformation.CustomerInformation.IsRapidCentralStation;
                    this.isIllinois = (this.customerInformation.PremisesAddress.State || '').trim().toUpperCase() === 'IL';
                    this.isCanada = (this.customerInformation.PremisesAddress.Country || '').trim().toUpperCase() === 'CAN';
                }
                const planName = ((dataContext.user.current.ServicePlanInfo || {}).ServicePlanName || '').toLowerCase();
                this.isProtectionPlan = planName.indexOf('protection') === 0;
            });
        this.dataContext.account.isEligibleForVideoAnalytics()
            .then((result) => {
                this.isEligibleForVideoAnalytics = result;
            });
    }

    $onInit() {
        this.showAddOnValidation = false;
        this.dataContext.account.getAddOns()
            .then((result) => {
                this.addOns = result;
                this.activeAddOns = _.filter(this.addOns, ['IsActive', true]);
                this.inAppPersonalSafetyButtonAddOn = _.filter(this.addOns,
                    (addOn) => { return addOn.Name.toLowerCase() == this.constants.AddOns.safetyButton.toLowerCase(); });
                this.videoAnalyticsAddOn = _.filter(this.activeAddOns,
                    (addOn) => { return addOn.Name.toLowerCase() == this.constants.AddOns.videoAnalytics.toLowerCase(); });
                this.AIDAddOns = _.filter(this.activeAddOns,
                    (addOn) => { return addOn.Name.toLowerCase() == this.constants.AddOns.AIDAddon.toLowerCase(); });
                _.forEach(this.AIDAddOns, (addon) => {
                    this.listOfAIDAddonServices.push(
                        {
                            servicePlanName: addon.ServicePlan + ': $' + addon.Price + '/month',
                            price: addon.Price,
                            addonId: addon.addonId
                        });
                });
                this.listOfAIDAddonServices.push(
                    {
                        servicePlanName: '0 Cameras (Remove)',
                        price: 0.00,
                        addonId: 0
                    });
                this.aiVideoSearchCatalogAddOn = _.find(this.activeAddOns,
                    (addOn) => { return addOn.Name.toLowerCase() === 'ai search add-on'; });
            });

        this.dataContext.account.getAccountAddOns()
            .then((result) => {
                this.accountAddOns = result;
                this.activeAccountAddOns = _.filter(this.accountAddOns, (result) => {
                    return result.DateRemoved == null;
                });
                // Detect active bundles first, then filter individual addons
                this.activeBundles = [];
                this.availableBundles = [];
                this.bundledAddonIds = [];
                this.$q.all([this.dataContext.account.getAddonBundles(), this.customerInfoReady])
                    .then((results) => {
                        const bundles = results[0];
                        if (bundles && bundles.length > 0) {
                            const BundleGrantSource = 5;
                            const bundleAddons = _.filter(this.activeAccountAddOns,
                                (a) => a.Source === BundleGrantSource && a.SourceReferenceId != null);
                            const groups = _.groupBy(bundleAddons, 'SourceReferenceId');
                            const enrolledBundleIds = [];
                            _.forEach(groups, (addonsInGroup, sourceRefId) => {
                                const matchedBundle = _.find(bundles, (b) => {
                                    return String(b.AddonBundleId || b.addonBundleId) === sourceRefId;
                                });
                                if (matchedBundle) {
                                    this.activeBundles.push(matchedBundle);
                                    enrolledBundleIds.push(matchedBundle.AddonBundleId || matchedBundle.addonBundleId);
                                    _.forEach(addonsInGroup, (a) => {
                                        this.bundledAddonIds.push(a.AccountAddOnID);
                                    });
                                }
                            });
                            // Only show Next Gen Suite if user is not enrolled in ANY bundle
                            // and is not in Illinois (AI Search restriction), Canada, or on Protection plan
                            if (this.activeBundles.length === 0 && !this.isIllinois && !this.isCanada && !this.isProtectionPlan) {
                                this.availableBundles = _.filter(bundles, (b) => {
                                    const code = (b.Code || b.code || '').toUpperCase();
                                    return code === 'NEXT_GEN_SUITE';
                                });
                            } else {
                                this.availableBundles = [];
                            }
                        }

                        // Filter out bundled addons from individual addon lists (for display/counts)
                        const nonBundledAddOns = _.filter(this.activeAccountAddOns, (a) => {
                            return this.bundledAddonIds.indexOf(a.AccountAddOnID) === -1;
                        });

                        // Use all active add-ons (including bundled) for enrollment eligibility checks
                        // to prevent offering duplicate standalone add-ons when already enrolled via a bundle
                        const allActiveForEligibility = this.activeAccountAddOns;

                        this.inAppPersonalSafetyButtonAddOns = _.filter(nonBundledAddOns,
                            (accAddOn) => {
                                return accAddOn.AddOn.Name.toLowerCase() == this.constants.AddOns.safetyButton.toLowerCase();
                            });
                        // Use all active (including bundled) for eligibility so bundle-enrolled Safety Button
                        // prevents the "Not Enrolled" section from showing
                        const allSafetyButtonAddOns = _.filter(allActiveForEligibility,
                            (accAddOn) => {
                                return accAddOn.AddOn.Name.toLowerCase() == this.constants.AddOns.safetyButton.toLowerCase();
                            });
                        this.accountvideoAnalyticAddOn = _.filter(allActiveForEligibility,
                            (accAddOn) => {
                                return accAddOn.AddOn.Name.toLowerCase() == this.constants.AddOns.videoAnalytics.toLowerCase();
                            });
                        this.accountSystemSafetyButtonAddOns = _.filter(allSafetyButtonAddOns, ['IsSystemAddOn', true]);
                        this.accountRetentionSafetyButtonAddOns = _.filter(allSafetyButtonAddOns,
                            (accAddOn) => {
                                return accAddOn.RetentionEpisodeId != null;
                            });
                        this.accountSystemRetentionSafetyButtonAddOnsQuantity = this.accountSystemSafetyButtonAddOns.length + this.accountRetentionSafetyButtonAddOns.length;
                        this.accountAdditionalSafetyButtonAddOns = _.filter(this.inAppPersonalSafetyButtonAddOns, (addOn) => {
                            return addOn.IsSystemAddOn == false && addOn.RetentionEpisodeId == null;
                        });
                        this.existingAdditionalAddOnsQuantity = this.accountAdditionalSafetyButtonAddOns.length;
                        this.additionalAddOnsQuantity = this.existingAdditionalAddOnsQuantity;
                        this.accountAIDAddOn = _.filter(nonBundledAddOns,
                            (accAddOn) => {
                                return accAddOn.AddOn.Name.toLowerCase() == this.constants.AddOns.AIDAddon.toLowerCase();
                            });
                        this.aidAddonServicePlanSelected = _.find(this.listOfAIDAddonServices, (aidAddon) => {
                            if (!this.accountAIDAddOn || this.accountAIDAddOn.length === 0) {
                                return false;
                            }
                            return aidAddon.addonId == this.accountAIDAddOn[0].addonId;
                        });
                        // AI Video Search
                        this.accountAIVideoSearchAddOn = _.find(allActiveForEligibility,
                            (accAddOn) => {
                                return accAddOn.AddOn.Name.toLowerCase() === 'ai search add-on';
                            });
                    });
            });
    }

    onCancel() {
        // The customer has stopped editing addOns without saving.
        this.stopEditing();
        this.additionalAddOnsQuantity = this.existingAdditionalAddOnsQuantity;
        this.showAddOnValidation = false;
    }

    getMonitoringAdcInfo() {
        return this.dataContext.emergency.getMonitoringAdcInfo().then((result) => {

            if (result.WbServicePlanName === 'Video Only') {
                    result.WbServicePlanName = 'Video Only';
            }

            this.monitoringAdcInfo = result;
        });
    }

    openAddAddOnModal(addonName) {
        let addon;
        if (addonName.toLowerCase() == this.constants.AddOns.safetyButton.toLowerCase()) {
            addon = this.inAppPersonalSafetyButtonAddOn;
        }
        if (addonName.toLowerCase() == this.constants.AddOns.AIDAddon.toLowerCase()) {
            addon = this.AIDAddOns;
        }
        const modalInstance = this.$uibModal.open({
            template: '<fp-add-add-on-modal config="config"></fp-add-add-on-modal>',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    data: {
                        addon: addon,
                        oldQuantity: this.existingAdditionalAddOnsQuantity,
                        newQuantity: this.additionalAddOnsQuantity
                    },
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss
                };
            },
            size: 'lg'
        });
    }

    editSafetyButtonAddOns() {
        // get 6 months prior date to the current date
        var today = new Date();
        var sixMonthPriordate = new Date(today.getFullYear(), today.getMonth() - 6, today.getDate());
        var formattedSixMonthPriordate = sixMonthPriordate.toLocaleDateString('en-ca');

        this.sixMonthPriorRemovedFeatureAccountAddOns = _.filter(this.accountAddOns, (result) => {
            return result.DateFeatureRemoved != null && result.DateFeatureRemoved >= formattedSixMonthPriordate;
        });
        this.isFeatureRemovedWithInSixMonths = this.sixMonthPriorRemovedFeatureAccountAddOns.length > 0 && this.additionalAddOnsQuantity === 0;

        if (this.existingAdditionalAddOnsQuantity != this.additionalAddOnsQuantity && !this.isFeatureRemovedWithInSixMonths && !_.isNil(this.additionalAddOnsQuantity)) {
            this.showAddOnValidation = false;
            const modalInstance = this.$uibModal.open({
                template: '<fp-confirm-add-on-modal config="config"></fp-confirm-add-on-modal>',
                controller: ($scope) => {
                    'ngInject';
                    $scope.config = {
                        data: {
                            safetyButtonAddOn: this.inAppPersonalSafetyButtonAddOn,
                            oldQuantity: this.existingAdditionalAddOnsQuantity,
                            newQuantity: this.additionalAddOnsQuantity
                        },
                        close: modalInstance.close,
                        dismiss: modalInstance.dismiss
                    };
                },
                size: 'lg'
            });
            modalInstance.result
                .then((result) => {                    
                })
                .finally(() => {
                    this.additionalAddOnsQuantity = this.existingAdditionalAddOnsQuantity;
                    this.showAddOnValidation = false;
                });
        }
        else if (this.isFeatureRemovedWithInSixMonths) {
            this.additionalAddOnsQuantity = this.existingAdditionalAddOnsQuantity;
            this.showAddOnValidation = false;
            const modalInstance = this.$uibModal.open({
                template: '<fp-error-add-on-modal config="config"></fp-error-add-on-modal>',
                controller: ($scope) => {
                    'ngInject';
                    $scope.config = {
                        data: {
                            safetyButtonAddOn: this.inAppPersonalSafetyButtonAddOn,
                            oldQuantity: this.existingAdditionalAddOnsQuantity,
                            newQuantity: this.additionalAddOnsQuantity,
                            isFeatureRemovedWithInSixMonths: this.isFeatureRemovedWithInSixMonths
                        },
                        close: modalInstance.close,
                        dismiss: modalInstance.dismiss
                    };
                },
                size: 'lg'
            });
        }
        else if (this.existingAdditionalAddOnsQuantity == this.additionalAddOnsQuantity) {
            this.showAddOnValidation = false;
            alert('The number of addOns to update should be different than current addOns.');
        }
        else if (_.isNil(this.additionalAddOnsQuantity)) {
            this.showAddOnValidation = true;
        }
    }

    addVideoAnalyticsAddOn() {
        this.dataContext.account.SetAddOnsForVideoAnalytics().then((result) => {
            if (result && result.success) {
                const modalInstance = this.$uibModal.open({
                    template: '<fp-success-add-on-modal config="config"></fp-success-add-on-modal>',
                    controller: ($scope) => {
                        'ngInject';
                        $scope.config = {
                            data: {
                                videoAnalytics: true
                            },
                            close: modalInstance.close,
                            dismiss: modalInstance.dismiss
                        };
                    },
                    size: 'lg'
                });
            }
            else {
                alert('Error adding video analytics.');
            }
        });
    }

    enrollAIVideoSearch() {
        const modalInstance = this.$uibModal.open({
            template: '<fp-add-add-on-modal config="config"></fp-add-add-on-modal>',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    data: {
                        isAIVideoSearch: true,
                        aiVideoSearchAddon: this.aiVideoSearchCatalogAddOn
                    },
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss
                };
            },
            size: 'lg'
        });
    }

    removeAIVideoSearch() {
        const modalInstance = this.$uibModal.open({
            template: '<fp-confirm-add-on-modal config="config"></fp-confirm-add-on-modal>',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    data: {
                        isAIVideoSearchRemove: true
                    },
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss
                };
            },
            size: 'lg'
        });
    }

    isAddonInBundle(accountAddOn) {
        return this.bundledAddonIds && this.bundledAddonIds.indexOf(accountAddOn.AccountAddOnID) !== -1;
    }

    removeBundle(bundle) {
        const bundleId = bundle.AddonBundleId || bundle.addonBundleId;
        const modalInstance = this.$uibModal.open({
            template: '<fp-confirm-add-on-modal config="config"></fp-confirm-add-on-modal>',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    data: {
                        isBundleRemove: true,
                        bundleName: bundle.Name || bundle.name,
                        bundleId: bundleId
                    },
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss
                };
            },
            size: 'lg'
        });
    }

    getBundleDescription(bundle) {
        const code = (bundle.Code || bundle.code || '').toUpperCase();
        const descriptions = {
            'NEXT_GEN_SUITE': 'AI Deterrence (1), Safety Button (1), & AI Search'
        };
        return descriptions[code] || '';
    }

    enrollBundle(bundle) {
        const modalInstance = this.$uibModal.open({
            template: '<fp-confirm-add-on-modal config="config"></fp-confirm-add-on-modal>',
            controller: ($scope) => {
                'ngInject';
                $scope.config = {
                    data: {
                        isBundleEnroll: true,
                        bundleName: bundle.Name || bundle.name,
                        bundlePrice: bundle.Price || bundle.price,
                        bundle: bundle
                    },
                    close: modalInstance.close,
                    dismiss: modalInstance.dismiss
                };
            },
            size: 'lg'
        });
    }

    onSelectAIDAddons() {
        if (this.aidAddonServicePlanSelected.addonId === this.accountAIDAddOn[0].addonId) {
            alert('You are currently enrolled to the Add-On selected.');
        } else {
            const isDowngrade = this.aidAddonServicePlanSelected.addonId < this.accountAIDAddOn[0].addonId;
            const aidAddon = _.find(this.AIDAddOns, (aidAddon) => {
                return aidAddon.addonId == this.aidAddonServicePlanSelected.addonId;
            });
            const isFeatureRemove = this.aidAddonServicePlanSelected.servicePlanName.substring(0, 1) == '0';
            const modalInstance = this.$uibModal.open({
                template: '<fp-confirm-add-on-modal config="config"></fp-confirm-add-on-modal>',
                controller: ($scope) => {
                    'ngInject';
                    $scope.config = {
                        data: {
                            aidAddonServicePlanSelected: this.aidAddonServicePlanSelected,
                            isDowngrade: isDowngrade,
                            aidAddon: aidAddon,
                            isFeatureRemove: isFeatureRemove
                        },
                        close: modalInstance.close,
                        dismiss: modalInstance.dismiss
                    };
                },
                size: 'lg'
            });
        }        
    }

    _trimProperties(entity) {
        for (let prop in entity) {
            let value = entity[prop];
            if (_.isString(value)) {
                entity[prop] = entity[prop].trim();
            }
        }
    }

    _showGenericSuccessAlert(dialogMessage) {
        this.alertService
            .get(this.ALERT_DIALOG)
            .setMessage(`Success! ${dialogMessage}`)
            .setType('success')
            .setTimeout(this.constants.alertDuration)
            .open();
    }

    _showGenericErrorAlert(dialogMessage) {

        this.alertService
            .get(this.ALERT_DIALOG)
            .setMessage(`Error. ${dialogMessage} Please try again.`)
            .setType('danger')
            .setTimeout(this.constants.alertDuration)
            .open();
    }
}

export default {
    template: template,
    bindings: {
        customerInfo: '<',
        isSaving: '<',
        isLoading: '<',
        states: '<'
    },
    controller: AccountBillingController
};